import { render, staticRenderFns } from "./EvalDiscussion.vue?vue&type=template&id=1b4a32af&scoped=true"
import script from "./EvalDiscussion.vue?vue&type=script&lang=js"
export * from "./EvalDiscussion.vue?vue&type=script&lang=js"
import style0 from "./EvalDiscussion.vue?vue&type=style&index=0&id=1b4a32af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a32af",
  null
  
)

export default component.exports